<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-none d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="https://www.wisely.cl" target="_blank">
        Wisely
      </b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>
    <span class="float-md-right d-none d-md-block">
      <b-img :src="appLogoImage" alt="logo" width="21" />
      Bond - IoT para industrias V.1.0.0
    </span>
    <span class="d-flex d-md-none justify-content-between w-100">
      <span>© {{ new Date().getFullYear() }}
        <b-link class="ml-25" href="https://www.wisely.cl" target="_blank">
          Wisely
        </b-link>
      </span>
      <span> <b-img :src="appLogoImage" alt="logo" width="21" /> Bond - V.1.0.0</span>
    </span>
  </p>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>
